<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/empresas">Empresas</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes da Empresa</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Empresa
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome da Empresa</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.nome_empresa"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CNPJ</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="['##.###.###/####-##']"
                  v-model="empresa.CNPJ"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="['#####-###']"
                  v-model="empresa.CEP"
                />
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.cidade"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Estado</label>
                <v-select
                  label="sigla"
                  v-model="empresa.estado"
                  class="form-select"
                  :options="estados"
                  :searchable="true"
                >
                </v-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Logradouro</label>
                <input
                  class="form-control"
                  v-model="empresa.logradouro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="empresa.bairro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  v-model="empresa.numero"
                  type="number"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a cor (Escura)</label>
                <div class="horizontal">
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cor_site_escura"
                  />
                  <input
                    type="color"
                    class="form-control"
                    v-model="empresa.cor_site_escura"
                    style="width: 38px;"
                  />
                </div>  
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a cor (Média)</label>
                <div class="horizontal">
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cor_site_media"
                  />
                  <input
                    type="color"
                    class="form-control"
                    v-model="empresa.cor_site_media"
                    style="width: 38px;"
                  />
                </div>  
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a cor (Clara)</label>
                <div class="horizontal">
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cor_site_clara"
                  />
                  <input
                    type="color"
                    class="form-control"
                    v-model="empresa.cor_site_clara"
                    style="width: 38px;"
                  />
                </div>  
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
							<div class="form-group">
								<label>Adicione uma Logo (JPG, PNG)</label>
								<input
                  @change="changeLogo"
                  ref="addImagem"
                  type="file"
                  class="form-control"
                />
							</div>
						</div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p class="pull-right">
                <button href="#0" class="btn_1 medium" @click="editaInformacoes()">Salvar</button>
              </p>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom mb-5">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-photo"></i>Logo
            </h2>
          </div>
          <div class="row">
            <div class="col-md-4 img">
              <img :src="empresa.arquivo_logo">
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- /container-fluid-->
    </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta, validaCampos, stripCNPJ } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      id_empresa: this.$route.params.id_empresa,
      empresa: {},
      search: "",
			isLoading: false,
			nova_logo: null,
      estados: [
        "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", 
        "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", 
        "RO", "RR", "RS", "SC", "SE", "SP", "TO"
      ]
    };
  },
  mounted() {
    let self = this;
    self.isLoading = true;
    axios.get(`empresas/${self.id_empresa}`)
      .then((res) => {
        self.empresa = res.data;
        this.empresa.arquivo_logo = axios.defaults.baseURL.slice(0, -3) + 'arquivos_logo/' + this.empresa.arquivo_logo
        self.isLoading = false;

      }, err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      })
  },
  methods: {
    editaInformacoes() {
      let self = this;

      if(validaCampos(undefined, self.empresa.CNPJ, undefined, undefined)) { 
				self.isLoading = true;

				let objRequest = new FormData();

				objRequest.append('nome_empresa', self.empresa.nome_empresa);
        objRequest.append('CNPJ', stripCNPJ(self.empresa.CNPJ));
        objRequest.append('CEP', self.empresa.CEP);
        objRequest.append('cidade', self.empresa.cidade);
        objRequest.append('estado', self.empresa.estado);
        objRequest.append('logradouro', self.empresa.logradouro);
        objRequest.append('bairro', self.empresa.bairro);
        objRequest.append('numero', self.empresa.numero);
        objRequest.append('cor_site_escura', self.empresa.cor_site_escura);
        objRequest.append('cor_site_media', self.empresa.cor_site_media);
        objRequest.append('cor_site_clara', self.empresa.cor_site_clara);

				if (self.nova_logo) {
					objRequest.append('arquivo_logo', self.nova_logo)
				}

        ajax("post", "empresas/" + self.empresa.id, objRequest)
          .then(() => {
            self.isLoading = false;
            alerta(
              "success",
              "Sucesso",
              "Informações foram atualizadas com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      }
		},
		changeLogo(e) {
			this.nova_logo = e.target.files[0];
			this.empresa.arquivo_logo = URL.createObjectURL(this.nova_logo)
		}
  }
};
</script>

<style>

.img {
  display: flex;
  align-items: center;
}

</style>
